/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MinimumDownpayment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function MinimumDownpayment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/Overview/PlanRules/MinimumDownpayment"
  
}) {
let rulesetCustomPaymentPlanRulesetMinDownpaymentValueData = fromData.useDataFormat({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.min_downpayment',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 data="ruleset.custom_payment_plan_ruleset.min_downpayment"
 format="/Data/format.js numberMoney"
 text={rulesetCustomPaymentPlanRulesetMinDownpaymentValueData}
/>
{children}
</React.Fragment>)
}